import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';

import { AuthService } from './auth.service';

@Injectable()

export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {

  }

  public canActivate(
    routeAsked: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {

    // Check if user is logged
    return this.authService.isLogged()
      .map((isLogged) => ({ isLogged, hasRights: isLogged }))

      // Check if user is good roles if data.userIs is specified in the route
      // like { path , component , canActivate: [AuthGuard], data: { userIs: 'admin|manager'} },
      .mergeMap(({ isLogged, hasRights }) => {
        if (!isLogged || !hasRights) return Observable.of({ isLogged, hasRights });

        if (routeAsked.data && routeAsked.data.userIs) {
          return this.authService.userIs(routeAsked.data.userIs)
            .map((rightOk) => ({ isLogged: true, hasRights: rightOk }));
        }
        else {
          return Observable.of({ isLogged, hasRights });
        }
      })

      // Check if user has good rights if data.userCan is specified in the route
      // like { path , component , canActivate: [AuthGuard], data: { userCan: 'admin|manager'} },
      .mergeMap(({ isLogged, hasRights }) => {
        if (!isLogged || !hasRights) return Observable.of({ isLogged, hasRights });

        if (routeAsked.data && routeAsked.data.userCan) {
          return this.authService.userCan(routeAsked.data.userCan)
            .map((rightOk) => ({ isLogged: true, hasRights: rightOk }));
        }
        else {
          return Observable.of({ isLogged, hasRights });
        }
      })
      .map(({ isLogged, hasRights }) => {
        if (isLogged) {
          if (!hasRights) {
            this.router.navigate(['/']);
            return false;
          }
          return true;
        }
        else {
          this.router.navigate(['/login'], {
            queryParams: {
              redirect: state.url,
            },
          });
        }
        return false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-guard.ts